// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/main.styl
// module id = 30
// module chunks = 0